import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatCardModule } from "@angular/material/card";
import { MatTableModule } from "@angular/material/table";
import { MatSelectModule } from "@angular/material/select";
import { ControlErrorsDirective } from "./form-helper/form-control-error/control-errors.directive";
import { ControlErrorComponent } from "./form-helper/form-control-error/control-error/control-error.component";
import { ControlErrorContainerDirective } from "./form-helper/form-control-error/control-error-container.directive";
import { FormSubmitDirective } from "./form-helper/form-control-error/form-submit.directive";
import { FormErrorFromServerBottomSheetComponent } from "./form-helper/form-control-error/form-error-from-server-bottomsheet/form-error-from-server-bottom-sheet.component";
import { EntityTitlePipe } from "./pipes/entity-title.pipe";
import { AppDatePipe } from "./pipes/app-date.pipe";
import { AppDateTimePipe } from "./pipes/app-date-time.pipe";
import { MatDividerModule } from "@angular/material/divider";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatBottomSheetModule } from "@angular/material/bottom-sheet";
import { MatInputModule } from "@angular/material/input";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatBadgeModule } from "@angular/material/badge";
import { CustomAddressFormComponent } from "./custom-address-form/custom-address-form.component";
import { MatListModule } from "@angular/material/list";
import { MatTabsModule } from "@angular/material/tabs";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatStepperModule } from "@angular/material/stepper";
import { FuseScrollbarDirective } from "@fuse/directives/scrollbar";
import { MatExpansionModule } from "@angular/material/expansion";
import { RouterModule } from "@angular/router";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatSidenavModule } from "@angular/material/sidenav";
import { FuseAlertComponent } from "@fuse/components/alert";
import { SingularizePipe } from "./pipes/singularize.pipe";
import { MatDialogModule } from "@angular/material/dialog";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { DynamicComponentDirective } from "./directives/dynamic-component.directive";
import { SecuredImageComponent } from "./components/secured-image.component";
import { BackGroundThemeComponent } from "./theme/back-ground-theme/back-ground-theme.component";
import { HasAnyAuthorityDirective } from "app/mock-api/common/auth/has-any-authority.directive";
import { MatMenuModule } from "@angular/material/menu";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { FilePreviewComponent } from "./file-preview/file-preview.component";
import { Field } from "@angular/forms/signals";
import { MatRadioModule } from "@angular/material/radio";

@NgModule({
  declarations: [
    ControlErrorsDirective,
    ControlErrorComponent,
    ControlErrorContainerDirective,
    FormSubmitDirective,
    FormErrorFromServerBottomSheetComponent,
    EntityTitlePipe,
    AppDatePipe,
    AppDateTimePipe,
    CustomAddressFormComponent,
    SingularizePipe,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSelectModule,
    MatDividerModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatSortModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    MatBadgeModule,
    MatListModule,
    MatTabsModule,
    MatProgressBarModule,
    MatToolbarModule,
    MatStepperModule,
    FuseScrollbarDirective,
    MatExpansionModule,
    MatAutocompleteModule,
    RouterModule,
    MatSidenavModule,
    FuseAlertComponent,
    MatDialogModule,
    MatButtonToggleModule,
    DynamicComponentDirective,
    SecuredImageComponent,
    BackGroundThemeComponent,
    HasAnyAuthorityDirective,
    FilePreviewComponent,
    Field,
    MatRadioModule,
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatSelectModule,
    MatDividerModule,
    MatPaginatorModule,
    MatSnackBarModule,
    MatSortModule,
    MatBottomSheetModule,
    MatMenuModule,
    MatCheckboxModule,
    MatButtonModule,
    MatIconModule,
    EntityTitlePipe,
    AppDatePipe,
    AppDateTimePipe,
    CustomAddressFormComponent,
    MatBadgeModule,
    MatListModule,
    MatTabsModule,
    MatProgressBarModule,
    MatToolbarModule,
    FormErrorFromServerBottomSheetComponent,
    MatStepperModule,
    FuseScrollbarDirective,
    MatExpansionModule,
    MatAutocompleteModule,
    ControlErrorsDirective,
    MatSidenavModule,
    FuseAlertComponent,
    SingularizePipe,
    MatButtonToggleModule,
    DynamicComponentDirective,
    SecuredImageComponent,
    BackGroundThemeComponent,
    HasAnyAuthorityDirective,
    FilePreviewComponent,
    Field,
    MatRadioModule,
  ],
})
export class SharedModule {}
